const BillsAndPaymentForm = () => {
  return <div>BillsAndPaymentForm</div>;
};

export default BillsAndPaymentForm;
